import { ChatTitle } from 'im.v2.component.elements.chat-title';
import { ChatAvatar, AvatarSize } from 'im.v2.component.elements.avatar';

import { AutoDelete } from '../../../elements/auto-delete/auto-delete';

// @vue/component
export const SupportPreview = {
	name: 'SupportPreview',
	components: { ChatAvatar, ChatTitle, AutoDelete },
	props: {
		dialogId: {
			type: String,
			required: true,
		},
	},
	computed:
	{
		AvatarSize: () => AvatarSize,
	},
	template: `
		<div class="bx-im-sidebar-main-preview__scope">
			<div class="bx-im-sidebar-main-preview-group-chat__avatar-container">
				<div class="bx-im-sidebar-main-preview-group-chat__avatar">
					<ChatAvatar :size="AvatarSize.XXXL" :avatarDialogId="dialogId" />
				</div>
				<ChatTitle :dialogId="dialogId" :twoLine="true" class="bx-im-sidebar-main-preview-group-chat__title" />
			</div>
			<div class="bx-im-sidebar-main-preview-group-chat__settings">
				<AutoDelete :dialogId="dialogId" />
			</div>
		</div>
	`,
};
